import {
    SET_FEDERAL_POLL_MAP,
    SET_POLL_MAP,
    SET_POLL_MAP_OVERLAY,
    SET_POLL_MAP_PARTIES,
    SET_POLL_MAP_YEAR,
    SET_POLL_MAP_LOCAL_DIVISION
} from '../actions';

const initialState = {
    yearDivision: 201910001,
    pollMapYear: 2019,
    pollMapLocalDivision: 10001
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_FEDERAL_POLL_MAP:
		    return { ...state, yearDivision:action.yearDivision};
        case SET_POLL_MAP:
            return { ...state, pollMap:action};            
        case SET_POLL_MAP_OVERLAY:
            return { ...state, pollMapOverlay:action.pollMapOverlay};                
        case SET_POLL_MAP_YEAR:
            return { ...state, pollMapYear:action.pollMapYear};                    
        case SET_POLL_MAP_LOCAL_DIVISION:
            return { ...state, pollMapLocalDivision:action.pollMapLocalDivision};                    
        case SET_POLL_MAP_PARTIES:
            return { ...state, parties:action.parties};                            
        default: 
		    return { ...state };
	}
}